import green from '@material-ui/core/colors/green';

const styles = theme => ({
    card: {
        display: 'flex',
        background: theme.palette.background.paper,
        position: 'relative',
    },
    content: {
        padding: theme.spacing(1)
    },
    details: {
        display: 'flex',
        flexDirection: 'column'
    },
    cover: {
        width: 150
    },
    primaryText: {
        fontWeight: 500,
        color: theme.palette.text.primary
    },
    secondaryText: {
        fontSize: 14,
        color: theme.palette.text.light
    },
    warning: {
        color: theme.palette.error.main
    },
    ok: {
        color: green[600]
    },
    avatar: {
        // width: 80,
        // height: 80,
        // border: 'solid 1px gainsboro'
    },
    avatarImage: {
        width: 80,
        height: 80,
        border: 'solid 1px gainsboro'
    }
});

export default styles;